export const NFE = 55;
export const NFCE = 65;
export const SAT = 59;



// WEBPACK FOOTER //
// ./src/public/api/docConst.js